import { render, staticRenderFns } from "./ProjectFormCard.vue?vue&type=template&id=2a807901"
import script from "./ProjectFormCard.vue?vue&type=script&lang=js"
export * from "./ProjectFormCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports